const VinValidator = (VehicleService) => {
  'ngInject'

  const require = 'ngModel'

  const link = (scope, element, attrs, ctrl) => {
    ctrl.$asyncValidators.checkVin = (modelValue, viewValue) => VehicleService.checkVin(modelValue.toUpperCase())
  }

  return { require, link }
}

export default VinValidator



// WEBPACK FOOTER //
// ./src/app/common/validators/vin.validator.js